import { Paper } from '@mui/material';
import { useProjectContext } from 'contexts/project.context';
import { memo } from 'react';
import { Handle, NodeProps, Position } from 'reactflow';
import { ProjectState } from 'store/api/models';

const StateNode = ({
  data,
  isConnectable,
  targetPosition = Position.Top,
  sourcePosition = Position.Bottom,
}: NodeProps<ProjectState>) => {
  const { stages, project_stages } = useProjectContext();

  return (
    <>
      <Handle
        type="target"
        position={targetPosition}
        isConnectable={isConnectable}
      />
      <Paper elevation={5} sx={{ p: 3 }}>
        {data.name}
      </Paper>
    </>
  );
};

StateNode.displayName = 'StateNode';

export default memo(StateNode);
